import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-724b9f60"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onContextmenu"]
const _hoisted_2 = {
  key: 1,
  class: "team-name__edit"
}


const __default__ = {
  name: 'TeamHeadInputEditor'
}

import { ref, nextTick, toRefs, VNodeRef, watch } from 'vue'
import { NInput, NTooltip, NEllipsis } from 'naive-ui'
import type { PropType } from 'vue'
import { vOnClickOutside } from '@vueuse/components'
import { useInputEditor } from '.'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: ''
  },
  className: {
    type: String,
    default: ''
  },
  onConfirm: {
    type: Function as PropType<
      (arg0: {
        name: string
        color: string
        next: () => void
      }) => boolean | void | Promise<void | boolean>
    >,
    default: () => null
  },
  showEmojiPanel: {
    type: Boolean,
    default: true
  },
  allowEdit: {
    type: Boolean,
    default: true
  },
  maxLength: {
    type: Number,
    default: 15
  }
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "8ac5281c": (_unref(descShowWidth)),
  "582bc938": (_unref(nameShowWidth))
}))



const showEdit = ref(false)
const isShowTooltip = ref(false)
const inputRuleTip = ref(`最多支持输入${props.maxLength}个汉字 `)
const dynamicInputRef = ref<HTMLDivElement | null>(null)
const dynamicInputStyle = ref('')

const { showDescEllipsis, descShowWidth, showNameEllipsis, nameShowWidth } =
  useInputEditor()

const updateShowEdit = (val = true) => {
  if (!props.allowEdit) return

  showEdit.value = val
  inputValue.value = name.value
  if (val) {
    handleInputChange()
    nextTick(() => {
      const inputElRef = nameInput.value?.$refs?.inputElRef

      if (inputElRef) {
        inputElRef.select()
      }
    })
  }
}
const nameInput = ref<null | {
  $refs: { inputElRef: HTMLInputElement }
}>(null)
const getInputTemplateRef = ((el: VNodeRef | undefined) => {
  if (el) {
    ;(nameInput.value as unknown as VNodeRef) = el
  }
}) as unknown as VNodeRef

const { name, color: pColor, className } = toRefs(props)
const color = ref(pColor.value)

watch(pColor, val => {
  color.value = val
})
const inputValue = ref(name.value)
const confirmEdit = async () => {
  if (checkInput(inputValue.value)) {
    inputValue.value = name.value
    isShowTooltip.value = false
    updateShowEdit(false)
    return
  }
  const next = () => {
    updateShowEdit(false)
    isShowTooltip.value = false
  }
  props.onConfirm({
    name: inputValue.value,
    color: color.value,
    next
  })
  inputValue.value = ''
  next()
}

const checkInput = (str: string) => {
  const reg = /[\\/:*?"<>|]/
  return reg.test(str)
}

const handleShowTooltip = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    updateShowEdit(false)
    return
  }

  if (checkInput(inputValue.value)) {
    inputRuleTip.value = `空间名称不能包含非法字符\\/:*?"<>|`
    isShowTooltip.value = true
  } else if (inputValue.value.length === props.maxLength) {
    inputRuleTip.value = `最多支持输入${props.maxLength}个汉字 `
    isShowTooltip.value = true
  } else {
    isShowTooltip.value = false
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const onContentmenu = () => {}

watch(dynamicInputRef, () => {
  dynamicInputStyle.value = `width: ${dynamicInputRef.value?.clientWidth}px`
})
const handleInputChange = () => {
  if (dynamicInputStyle.value !== `width: fit-content;`) {
    dynamicInputStyle.value = `width: fit-content;`
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _unref(className),
      {
        'team-name--overflow':
          _unref(name).length > 7 && _unref(className) === 'team-name' && _unref(showNameEllipsis)
      },
      {
        'team-desc--overflow':
          _unref(name).length > 7 && _unref(className) === 'team-desc' && _unref(showDescEllipsis)
      }
    ]),
    onContextmenu: _withModifiers(onContentmenu, ["stop","prevent"]),
    ref_key: "dynamicInputRef",
    ref: dynamicInputRef
  }, [
    (!showEdit.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["team-content", [
        { 'team-content--allow-edit': __props.allowEdit },
        { 'team-content-no-edit': !__props.allowEdit }
      ]]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateShowEdit(true)))
        }, [
          _createVNode(_unref(NEllipsis), { tooltip: { placement: 'bottom' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(name)), 1)
            ]),
            _: 1
          })
        ], 2))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(NTooltip), {
            show: isShowTooltip.value,
            placement: "bottom-start",
            "show-arrow": false,
            class: "team-tooltip-style"
          }, {
            trigger: _withCtx(() => [
              _createVNode(_unref(NInput), {
                ref: _unref(getInputTemplateRef),
                placeholder: "",
                size: "small",
                class: "team-name-input",
                autosize: "",
                style: _normalizeStyle(dynamicInputStyle.value),
                maxlength: __props.maxLength,
                value: inputValue.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
                onKeydown: _withKeys(confirmEdit, ["enter"]),
                onKeyup: handleShowTooltip
              }, null, 8, ["style", "maxlength", "value", "onKeydown"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(inputRuleTip.value), 1)
            ]),
            _: 1
          }, 8, ["show"])
        ])), [
          [_unref(vOnClickOutside), confirmEdit]
        ])
  ], 42, _hoisted_1))
}
}

})